import { useUserData } from '@/services/user';
import { AVOID_INDUSTRY_OPTIONS } from '@common/inputs';
import { AvoidIndustry, InvestmentProfile } from '@common/types';
import { IdvForm } from '../IdvForm';
import {
    PersonalizedInvestmentContent,
    PersonalizedInvestmentsHeader,
} from './SupportedValuesView';

type T = { avoidIndustries?: InvestmentProfile['avoid_industries'] };

export const AvoidIndustriesView = () => {
    const { userInfo } = useUserData();
    const defaultValues = userInfo?.investmentProfile?.avoid_industries;

    return (
        <IdvForm<T>
            initValues={(userProfile) => ({
                avoidIndustries:
                    userProfile?.investmentProfile?.avoid_industries ||
                    undefined,
            })}
            toMutationInput={({ avoidIndustries }) => ({
                investmentProfile: { avoid_industries: avoidIndustries },
            })}
            backNextNavProps={{
                onClickEventParams: {
                    location: 'IDV > AvoidIndustriesView',
                },
            }}
        >
            <PersonalizedInvestmentsHeader />
            <PersonalizedInvestmentContent<AvoidIndustry>
                title="Industries to avoid"
                accentColor="red.500"
                defaultValues={defaultValues}
                options={AVOID_INDUSTRY_OPTIONS}
                infoText={[
                    'When you avoid an industry, we’ll remove companies from your portfolio that match that value.',
                    'ie. We may ordinarily invest 1-2% of your portfolio into a specific company that offers payday loans. If you choose to avoid that, we’ll remove them from your portfolio.',
                ]}
            >
                {(values) => (
                    <IdvForm.Input<T>
                        name="avoidIndustries"
                        label=""
                        value={values}
                        display="none"
                    />
                )}
            </PersonalizedInvestmentContent>
        </IdvForm>
    );
};
